import type { RewardPoolSwapType } from '@api/types/rewardPools';
import { REWARD_POOL_SWAP_TYPE } from '@api/types/rewardPools';

export const SwapTypeLabelMap: Record<RewardPoolSwapType, string> = {
  [REWARD_POOL_SWAP_TYPE.ALL]: 'Sell and Buy',
  [REWARD_POOL_SWAP_TYPE.BUY]: 'Buy',
  [REWARD_POOL_SWAP_TYPE.SELL]: 'Sell',
};

export const SwapTypeContinuousMap: Record<RewardPoolSwapType, string> = {
  [REWARD_POOL_SWAP_TYPE.ALL]: 'Selling and Buying',
  [REWARD_POOL_SWAP_TYPE.BUY]: 'Buying',
  [REWARD_POOL_SWAP_TYPE.SELL]: 'Selling',
};
